import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,Checkbox,
  TextField,Table,TableHead,TableCell,TableContainer,TableRow,
  Button,
  useRadioGroup,
  createFilterOptions,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  FormHelperText,
  Container
} from '@mui/material';
import Scrollbar from "src/components/Scrollbar";

import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import { getClientList } from 'src/api/analytics';
import { getUserDetails } from 'src/api/addAgent';
import { getCamerasList } from 'src/api/analytics';
import { setClientAgent } from 'src/api/analytics';
import { getClientAssignData } from 'src/api/analytics';
import { getClientProperties } from 'src/api/ShiftMaster';
import { assign } from 'lodash';
import client from 'src/api/clients';
import { faL } from '@fortawesome/free-solid-svg-icons';
import Page from 'src/components/Page';

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

const normalizeDisplayName = (name) =>
  String(name || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

const buildUniqueClientOptions = (clients) => {
  const grouped = new Map();

  (clients || []).forEach((clientItem) => {
    const key = normalizeDisplayName(clientItem?.displayname);
    if (!key) return;

    if (!grouped.has(key)) {
      grouped.set(key, []);
    }

    grouped.get(key).push(clientItem);
  });

  return Array.from(grouped.values()).map((groupItems) => {
    if (groupItems.length === 1) return groupItems[0];

    const assignTargets = new Set(
      groupItems
        .map((item) => Number(item.AssignClient || 0))
        .filter((assignId) => assignId > 0)
    );

    const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
    if (mappedMain) return mappedMain;

    const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
    return rootEntry || groupItems[0];
  });
};

const normalizeLocations = (locations) =>
  Array.from(
    new Map(
      (Array.isArray(locations) ? locations : (locations ? [locations] : []))
        .map((locationItem) => ({
          ...locationItem,
          ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
          Location: String(locationItem?.Location || locationItem?.name || '').trim(),
        }))
        .filter((locationItem) => locationItem.ID > 0)
        .map((locationItem) => [locationItem.ID, locationItem])
    ).values()
  );

const getAssignedLocationLabel = (item) => {
  const locationValue = item?.details?.Location ?? item?.details?.Locations ?? item?.Location ?? item?.location;

  if (Array.isArray(locationValue)) {
    return locationValue.filter(Boolean).join(', ');
  }

  if (typeof locationValue === 'string') {
    return locationValue;
  }

  const cameraLocations = item?.details?.camera_details
    ?.flat?.()
    ?.map?.((cameraItem) => cameraItem?.Location)
    ?.filter?.(Boolean);

  return cameraLocations && cameraLocations.length > 0
    ? [...new Set(cameraLocations)].join(', ')
    : '';
};

const getAssignedLocationNames = (item) => {
  const rawLocations = item?.details?.Location ?? item?.details?.Locations ?? item?.Location ?? item?.location;

  if (Array.isArray(rawLocations)) {
    return [...new Set(rawLocations.map((value) => String(value || '').trim()).filter(Boolean))];
  }

  if (typeof rawLocations === 'string') {
    return [...new Set(rawLocations.split(',').map((value) => value.trim()).filter(Boolean))];
  }

  const cameraLocations = item?.details?.camera_details
    ?.flat?.()
    ?.map?.((cameraItem) => String(cameraItem?.Location || '').trim())
    ?.filter?.(Boolean);

  return cameraLocations && cameraLocations.length > 0 ? [...new Set(cameraLocations)] : [];
};


function ClientAssign() {
  // State variables
  const [clientType, setClientType] = useState('');
  const [dilogeClientType,setDilogClientType] = useState('')
  const [selectedclients, setSelectedcllientList] = useState([]);
  const [dilogclients, setdilogcllientList] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState([]);
  const [selectedCameras, setSelectedCameras] = useState([]);

  // response Data
  const [clientList,setClientList] = useState([]);
  const [clientListType,setSelectedClientListType] = useState([]);
  const [dilogListType,setdilogListType] = useState([]);
  const [assignedData,setClientAssignedData] = useState([]);
  const [agentList,setAgentList] = useState([]);
  const [userTypeList,setUserTypeData] = useState([]);

  const [camerasList,setCamerasList] = useState([]);
  const [clientCameraList,setClientCameraList] =  useState([]);

  const [editedData,setEditedData] = useState([])
  const [openDialog,setOpenDialog] = useState(false)

  const [clientTypeError, setClientTypeError] = useState('');
  const [track,setTrack] = useState(false)

  const [checkValue,setCheckValue]=useState(false)
  const [inputValue, setInputValue] = useState([]);
  const [activeCameras, setActiveCameras] = useState([])
  const [copyCams,setCopyCams] = useState([])

  const [error,setError] = useState(false)
  const [errorMessage,setErrorMessage] = useState('')

  const [tableDialog,setTableDilog] = useState(false)
  const [tableData,setTableData] = useState([])

  const [clientError, setClientError] = useState('');
  const [agentError, setAgentError] = useState('');
  const [cameraError, setCameraError] = useState('');
  const [dilogCameras,setDilogCameras] = useState([])

  const [clientTypeEditError, setClientTypeEditError] = useState(false);
  const [clientEditError, setClientEditError] = useState(false);
  const [agentEditError, setAgentEditError] = useState(false);
  const [activeEditError,setActiveEditError] = useState(false)

  const [isUpdating, setIsUpdating] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); 
  
  const [disableAgent,setDisableAgent] = useState(false)
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [locationCheckValue, setLocationCheckValue] = useState(false);
  const [editClientLocationOptions, setEditClientLocationOptions] = useState([]);
  const [editSelectedClientLocations, setEditSelectedClientLocations] = useState([]);
  const [editLocationCheckValue, setEditLocationCheckValue] = useState(false);


 useEffect(()=>{
  getClientList((response) => {
    if (response.status === 200) {
      setClientList(response.data);
    }
  });
  getUserDetails((response) => {
    if (response.status === 200) {
      // Filter cameras where usertype is 4
    
      // console.log(response.data)
      // console.log()
      let filteredAgent = response.data.filter(val => val.Status === 1)
      setAgentList(filteredAgent);
    }
  });
  
  getCamerasList((response) =>{
    if(response.status === 200){
      setCamerasList(response.data);
    } 
  })

  getClientAssignData((response) =>{
    if(response.status === 200){
      setClientAssignedData(response.data);
    }
  })
 },[])

//  useEffect(()=>{
//   console.log(selectedAgent)
//  },[selectedAgent])

 useEffect(()=>{
  const selectedUsers = agentList
  setUserTypeData(selectedUsers);
 },[agentList])

  useEffect(()=>{
  setSelectedAgent([])
  const Type = editedData.details && 
                     editedData.details.ClientId && 
                     editedData.details.ClientId.length > 0 
                     ? clientList.find(client => client.ID === editedData.details.ClientId[0])?.ClientType 
                     : null;

  const agentId = editedData && editedData.details ? editedData.details.AgentId :''
  const selectedAgents = agentList.filter((agents)=>agents.ID === agentId)
  setSelectedAgent(selectedAgents)

  setDilogClientType(Type || '')
  if(Type === "INDIA"){
   const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA')
   const sortedData = [...indiaClients].sort((a,b)=>
    a.displayname.trim().localeCompare(b.displayname.trim())
   )
   setdilogListType(buildUniqueClientOptions(sortedData))
  }
  else if(Type === "US"){
   const usClients = clientList.filter((row) => row.ClientType === 'US');
   const sortedData = [...usClients].sort((a,b)=>
    a.displayname.trim().localeCompare(b.displayname.trim())
   )
   setdilogListType(buildUniqueClientOptions(sortedData))
  }
 },[openDialog])

 useEffect(()=>{
  setdilogListType([])

  if(dilogeClientType === "INDIA"){
    const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA');
    const sortedData = [...indiaClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
    setdilogListType(buildUniqueClientOptions(sortedData))
  }
  else if(dilogeClientType === "US"){
    const usClients = clientList.filter((row) => row.ClientType === 'US');
    const sortedData = [...usClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
    setdilogListType(buildUniqueClientOptions(sortedData))
  }

  if(dilogeClientType){
   
    const clientIds = clientList.map(client => client.ID && client.ClientType === dilogeClientType);
    let allCameras = Object.keys(editedData).length > 0 
    ? camerasList.filter((camera) => editedData.details.ClientId.includes(camera.clientid)) 
    : [];

    let uniqueId = [...new Set(allCameras.map(item => item.clientid))]
    let ct = clientList.filter((clients)=>uniqueId.includes(clients.ID) && clients.ClientType === dilogeClientType).map(val => val.ID)

    let clientCameras = allCameras.filter(client =>ct.includes(client.clientid))

    setDilogCameras(clientCameras)

    const deviceIds = editedData.details.camera_details.flat().map(camera => camera.DeviceId);
    const filteredCameras = camerasList.filter(camera => deviceIds.includes(camera.deviceid));
    const selectedClients = dilogclients.filter(clients => clients.ClientType === dilogeClientType).map(id=>id.ID)
    const activeCams = filteredCameras.filter (cams =>selectedClients.includes(cams.clientid)).map(divid => divid.deviceid)
    const copyCams = filteredCameras.filter (cams =>!selectedClients.includes(cams.clientid)).map(divid => divid.deviceid)
    setActiveCameras(activeCams)
    setCopyCams(copyCams)
  }
 },[dilogeClientType])

  useEffect(() =>{
    if(clientType === "INDIA"){
     
     const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType!==0);
     const sortedData = [...indiaClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
     setSelectedClientListType(buildUniqueClientOptions(sortedData))
    }
    else if(clientType === "US") {
     const usClients = clientList.filter((row) => row.ClientType === 'US' && row.EnvironmentType!==0);
     const sortedData = [...usClients].sort((a,b)=>
      a.displayname.trim().localeCompare(b.displayname.trim())
    )
     setSelectedClientListType(buildUniqueClientOptions(sortedData))
    }
  },[clientType])

  useEffect(()=>{
    const selectedClient = selectedclients[0];

    if (!selectedClient) {
      setClientCameraList([]);
      setClientLocationOptions([]);
      setSelectedClientLocations([]);
      setLocationCheckValue(false);
      return;
    }

    getClientProperties({ AssignClient: String(selectedClient.ID) }, (response) => {
      if (response.status === 200) {
        const normalizedLocations = normalizeLocations(response.data);
        setClientLocationOptions(normalizedLocations);

        if (normalizedLocations.length > 0) {
          setClientCameraList([]);
          return;
        }
      }

      const selectedCameras = camerasList.filter(
        (camera) => Number(camera?.clientid ?? 0) === Number(selectedClient.ID)
      );
      setClientCameraList(selectedCameras);
    });
  },[selectedclients, camerasList])

  useEffect(() => {
    if (clientLocationOptions.length === 0) return;

    if (selectedClientLocations.length === 0) {
      setClientCameraList([]);
      return;
    }

    const selectedLocationIdSet = new Set(selectedClientLocations.map((id) => String(id)));
    const filteredCameras = camerasList.filter((camera) => {
      const deviceClientId = String(camera?.clientid ?? camera?.client_id ?? camera?.ClientId ?? '');
      return deviceClientId !== '' && selectedLocationIdSet.has(deviceClientId);
    });

    setClientCameraList(filteredCameras);
  }, [selectedClientLocations, clientLocationOptions, camerasList]);

  useEffect(() => {
    const selectedClient = dilogclients[0];

    if (!selectedClient) {
      setEditClientLocationOptions([]);
      setEditSelectedClientLocations([]);
      setEditLocationCheckValue(false);
      setDilogCameras([]);
      return;
    }

    getClientProperties({ AssignClient: String(selectedClient.ID) }, (response) => {
      if (response.status === 200) {
        const normalizedLocations = normalizeLocations(response.data);
        setEditClientLocationOptions(normalizedLocations);

        if (normalizedLocations.length > 0) {
          const assignedLocationNames = getAssignedLocationNames(editedData).map((locationName) =>
            locationName.toLowerCase()
          );
          const matchedLocationIds = normalizedLocations
            .filter((locationItem) =>
              assignedLocationNames.includes(String(locationItem.Location || '').trim().toLowerCase())
            )
            .map((locationItem) => locationItem.ID || locationItem.id);

          setEditSelectedClientLocations(matchedLocationIds);
          setEditLocationCheckValue(
            normalizedLocations.length > 0 && matchedLocationIds.length === normalizedLocations.length
          );
          setDilogCameras([]);
          return;
        }
      }

      setEditSelectedClientLocations([]);
      setEditLocationCheckValue(false);
      const filteredCameras = camerasList.filter(
        (camera) => Number(camera?.clientid ?? 0) === Number(selectedClient.ID)
      );
      setDilogCameras(filteredCameras);
    });
  }, [dilogclients, camerasList, editedData]);

  useEffect(() => {
    if (editClientLocationOptions.length === 0) return;

    if (editSelectedClientLocations.length === 0) {
      setDilogCameras([]);
      return;
    }

    const selectedLocationIdSet = new Set(editSelectedClientLocations.map((id) => String(id)));
    const filteredCameras = camerasList.filter((camera) => {
      const deviceClientId = String(camera?.clientid ?? camera?.client_id ?? camera?.ClientId ?? '');
      return deviceClientId !== '' && selectedLocationIdSet.has(deviceClientId);
    });

    setDilogCameras(filteredCameras);

    const assignedDeviceIds = editedData?.details?.camera_details?.flat?.().map((camera) => camera.DeviceId) || [];
    const matchedAssignedCameraIds = filteredCameras
      .filter((camera) => assignedDeviceIds.includes(camera.deviceid))
      .map((camera) => camera.deviceid);

    if (matchedAssignedCameraIds.length > 0) {
      setActiveCameras(matchedAssignedCameraIds);
    }
  }, [editSelectedClientLocations, editClientLocationOptions, camerasList]);


  // Handlers
  const handleClientTypeChange = (event) => {
    setClientType(event.target.value);
    setClientTypeError(event.target.value ? '' : 'Client Type is required');
    setActiveCameras([])
    setClientCameraList([])
    setSelectedAgent([]);
    setSelectedcllientList([])
  };

 

  const handleAdd = () =>{
  
    setClientTypeError('');
    setClientError('');
    setAgentError('');
    setCameraError('');

    setErrorMessage('')
    setError(false)
    setOpenDialog(false)

    setClientType('')
    


    if (!clientType) {
      setClientTypeError('Please Select Client Type');
    }

    if (selectedclients.length === 0) {
      setClientError('Please Select Client');
    }

    if (selectedAgent.length === 0) {
      setAgentError('Please Select Agent');
    }

    if (activeCameras.length === 0) {
      setCameraError('Please Select Cameras');
    }

    if (clientTypeError || clientError || agentError || cameraError) {
      return;
    }

    const AgentIds = selectedAgent.map(agent => agent.ID);

    if(selectedclients.length === 0 || activeCameras.length === 0 || AgentIds.length === 0){

    }

    const result =assignedData && assignedData.reduce((acc, item) => {
      if (AgentIds.includes(item.details.AgentId)) {
          acc[item.details.AgentId] = item.details.camera_details
              .flat() 
              .map(camera => camera.DeviceId);
      }
      return acc;
    }, {});
  
    let List = [];let error = []
    selectedAgent.forEach((item,inedx)=>{
      const agentId = item.ID;
      if(result && Object.keys(result).length>0){
        if(result[agentId]){
          const existingCameras = result[agentId]
          const currentCameras = activeCameras

          const commonCameras = existingCameras.filter(camera => currentCameras.includes(camera));

          if(commonCameras.length>0){
            let cameraNames = commonCameras.join(', ')
              const deviceNames = commonCameras.map(deviceId => {
              const device = camerasList.find(device => device.deviceid === deviceId);
              return device ? device.devicename : null; 
            }).filter(name => name !== null);
            
            const deviceNamesString = deviceNames.length > 0 ? deviceNames.join(', ') : '';
            
            error.push(`Agent :${item.displayname} is already assigned to the Camera: ${deviceNamesString}`)
          }

          const mergedCams = [...existingCameras,...currentCameras]

          List.push({
            AgentId: agentId,
            CameraId: mergedCams.join(','),
            Type:"add"
          });

        }
        else{
          List.push({
            AgentId: agentId,
            CameraId: activeCameras.join(','),
            Type:"add"
          });
        }
      }
      else{
        List.push({
          AgentId: agentId,
          CameraId: activeCameras.join(','),
          Type:"add"
        });
      }
    })

    if(error.length>0){
      
     // let message = error.join('\n'); 
      setErrorMessage(error)
      setError(true)
      return;
    }

    // console.log(List)

    if(List.length>0){
        setClientAgent(List,(response)=>{
        if(response.status === 200){
          // console.log("clilnet agnet ");       
          getClientAssignData((response) =>{
            if(response.status === 200){
              setClientAssignedData(response.data);
              handleClear()
            }
          })
        }
      })
    }
  }


    //let isClientAvail = assignedData.filter(item=>item.details.)

  // const handleAdd = () => {
  //    const AgentIds = selectedAgent.map(agent => agent.ID);
  //    console.log(AgentIds)
  //    console.log(assignedData)
  //    const matchedData = assignedData.filter(item => 
  //     AgentIds.includes(item.details.AgentId)
  //     );
  //     console.log(matchedData)

  //     if (matchedData.length > 0) {
  //       let allClientNames = matchedData.flatMap(item => item.details.ClientName);
  //       let uniqueClientNames = [...new Set(allClientNames)];
  
  //       let clientNames = uniqueClientNames.join(', ');
  //       let agentNames = matchedData.map(item => item.details.agent_name).join(', ');
    
  //       console.log("Client Names:", clientNames);
  //       console.log("Agent Names:", agentNames);

  //       if(agentNames && clientNames){
  //       setErrorMessage(`${agentNames} are already assigned to the Client : ${clientNames}`)
  //       setError(true)
  //       return;
  //       }

  //       const agentCameraMap = new Map();

  //       matchedData.forEach(item => {
  //         const { AgentName, CameraDetails } = item.details;
  //         if (!agentCameraMap.has(AgentName)) {
  //             agentCameraMap.set(AgentName, []);
  //         }
  //         agentCameraMap.get(AgentName).push(...CameraDetails);
  //       });
  
  //     const agentCameraDetails = Array.from(agentCameraMap.entries()).map(([agent, cameras]) => ({
  //         agent,
  //         cameras: [...new Set(cameras)]
  //       }));

  //       console.log(agentCameraDetails)
  //     }
  
  //   // const CameraIds = selectedCameras.map(camera => camera.deviceid);
  //   const CameraIds = activeCameras.join(',').toString();
  //    const data = {
  //     "AgentId": `${AgentIds}`,
  //     "CameraId": `${CameraIds}`
  //   }

  //   // setClientAgent(data,(response)=>{
  //   //   if(response.status === 200){
  //   //     console.log("clilnet agnet ");       
  //   //     getClientAssignData((response) =>{
  //   //       if(response.status === 200){
  //   //         setClientAssignedData(response.data);
  //   //       }
  //   //     })
  //   //   }
  //   // })
  // };

  // const handleClear = () => {
  //   setClientType('');
  //   //setsele(null);
  //   setSelectedAgent(null);
  //   //setSelectedCamera(null);
  //   setClientTypeError('');
  // };

  const handleClear = () => {
    setClientType('');
    setSelectedcllientList([]);
    setSelectedAgent([]);
    setActiveCameras([]);
    setClientTypeError('');
    setClientError('');
    setAgentError('');
    setCameraError('');
    setDilogClientType('');
    setdilogcllientList([]);
    setDilogCameras([]);
    setCheckValue(false);
    setSelectedClientListType([])
    setCopyCams([])
    setDisableAgent(false)
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setLocationCheckValue(false)
    setEditClientLocationOptions([])
    setEditSelectedClientLocations([])
    setEditLocationCheckValue(false)
  };

  const handleClientChange = (event,newClient) =>{
    setCheckValue(false)
    setClientError('')
    setActiveCameras([])
  if (event.key === 'Backspace') {
      return; 
  }
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setLocationCheckValue(false)
    setSelectedcllientList(newClient ? [newClient] : [])
  }

  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    return [{ title: 'Select All', all: true }, ...filtered];
  };

  const handleLocationFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return options.length > 0 ? [{ title: 'Select All', selectall: true }, ...filtered] : filtered;
  };

  const handleLocationChange = (_, value) => {
    let nextSelectedLocations = [];

    if (value.some((obj) => obj.hasOwnProperty('selectall'))) {
      nextSelectedLocations = locationCheckValue
        ? []
        : clientLocationOptions.map((locationItem) => locationItem.ID || locationItem.id);
    } else {
      nextSelectedLocations = value.map((locationItem) => locationItem.ID || locationItem.id);
    }

    setSelectedClientLocations(nextSelectedLocations);
    setLocationCheckValue(
      clientLocationOptions.length > 0 && nextSelectedLocations.length === clientLocationOptions.length
    );
    setActiveCameras([]);
    setCheckValue(false);
  };

  const handleEditLocationChange = (_, value) => {
    let nextSelectedLocations = [];

    if (value.some((obj) => obj.hasOwnProperty('selectall'))) {
      nextSelectedLocations = editLocationCheckValue
        ? []
        : editClientLocationOptions.map((locationItem) => locationItem.ID || locationItem.id);
    } else {
      nextSelectedLocations = value.map((locationItem) => locationItem.ID || locationItem.id);
    }

    setEditSelectedClientLocations(nextSelectedLocations);
    setEditLocationCheckValue(
      editClientLocationOptions.length > 0 && nextSelectedLocations.length === editClientLocationOptions.length
    );
    setActiveCameras([]);
    setCheckValue(false);
  };



  const handleDilogCameraSelection = (_, selectedCameras) => {
    const containsAll = selectedCameras.some(obj => obj.hasOwnProperty('all'));

    if (containsAll) {
        if (activeCameras.length === dilogCameras.length) {
            setActiveCameras([]);
        } else {
            const allCameraIds = dilogCameras.map(camera => camera.deviceid);
            setActiveCameras(allCameraIds);
        }
    } else {
        const selectedCameraIds = selectedCameras.map(camera => camera.deviceid);
        setActiveCameras(selectedCameraIds);
    }
};

  const handleCameraSelection = (event, value) =>{
    setCameraError('')
    let actCams=[];
  if (value.some(obj => obj.hasOwnProperty('all'))){
    if(activeCameras.length===clientCameraList.length){
      setActiveCameras([])
      setCheckValue(false)
    }
    else{
      clientCameraList.forEach(item=>{
        actCams.push(item.deviceid)
      })
      setActiveCameras(actCams)
      setCheckValue(true)
    }
  }
  else{
    let id=value[0].deviceid;
    if(activeCameras.includes(id)){
      let filterArr = activeCameras.filter(devid => devid !== id);
      //console.log(typeof activeClients[0]);
      setActiveCameras(filterArr);
      if(checkValue){
        setCheckValue(false)
      }
    }
    else{
      setActiveCameras((prv)=>[...prv,id])
    }
  }
  }

  useEffect(()=>{
    if(activeCameras.length===clientCameraList.length && activeCameras.length>0){
      setCheckValue(true)
    }
  },[activeCameras])

  const handleUpdate = ()=>{
    
    
    setClientTypeEditError(false)
    setClientEditError(false)
    setAgentEditError(false)
    setActiveEditError(false)
    
    let List = [];let error = []

    let hasError = false;

    if (!dilogeClientType) {
        setClientTypeEditError(true);
        hasError = true;
    }

    // if (selectedAgent.length === 0) {
    //   setAgentEditError(true);
    //   hasError = true;
    // }

    if (hasError) {
        return; 
    }
    setIsUpdating(true);
    setIsButtonDisabled(true);
    const AgentIds = selectedAgent.map(agent => agent.ID);
    const existenceAgentId = editedData.details.AgentId;
    let existingCamers = editedData.details.camera_details.flat().map(item=>item.DeviceId)
    const remaingCamers = copyCams
    existingCamers = remaingCamers.length > 0 ? existingCamers.filter(value => !remaingCamers.includes(value)) : existingCamers
    const selectedAgents = editedData && editedData.details ? editedData.details.AgentId : [];
    const removedAgent = AgentIds.filter(agentID => selectedAgents === (agentID));

    const isContainsMultipleTypes = [... new Set(dilogclients.map(val => val.ClientType))].length
    const remaingCams = copyCams
    const newAgents = AgentIds.filter (agent => existenceAgentId !== agent)

    selectedAgent.forEach((item,inedx)=>{    
      const agentId = item.ID;    
      if(existenceAgentId === agentId){
            List.push({
                      AgentId: agentId,
                      CameraId:isContainsMultipleTypes > 1 && remaingCams.length > 0 ? [...remaingCams,...activeCameras].join(',') : activeCameras.join(','),
                      Type : 'add'
              })
            const removableCameras = existingCamers.filter(val => !activeCameras.includes(val));
            if(existingCamers.length !== activeCameras.length || removableCameras.length>0){
              let removedCams = existingCamers.filter(val=>!activeCameras.includes(val));
              if(removedCams.length > 0){
                List.push({
                  AgentId: agentId,
                  CameraId: removedCams.join(','),
                  Type : 'remove'
                })
              }
            }
      }
      else{
        const deviceIds = [];

        if(assignedData.length>0){
          assignedData.forEach(agent => {
            if (agent.details.AgentId === agentId) {
                agent.details.camera_details.forEach(clientCameras => {
                    clientCameras.forEach(camera => {
                        deviceIds.push(camera.DeviceId);
                    });
                });
            }
          });
        }
        // console.log(deviceIds)
        if(deviceIds.length > 0){
            List.push({
              AgentId: agentId,
              CameraId: deviceIds.join(','),
              Type : 'remove'
            })
        }
        List.push({
          AgentId: agentId,
          CameraId: isContainsMultipleTypes > 1 && remaingCams.length > 0 ? [...remaingCams,...activeCameras].join(',') : activeCameras.join(','),
          Type : 'add'
        })
      }
    })

    if(activeCameras.length === 0){
      List = [];
      if(AgentIds.length > 0){
        AgentIds.forEach((val)=>{
          if(existingCamers.length!==0){
            List.push({
              AgentId : val,
              CameraId : existingCamers.join(','),
              Type : 'remove'
            })
          }
        })
      }
    }
    
    
    if(error.length>0){
      setErrorMessage(error)
      setError(true)
      setIsUpdating(false);
      setIsButtonDisabled(false);
      return
    }
    // console.log(List)
      if(List.length>0){
        setClientAgent(List,(response)=>{
        if(response.status === 200){
          // console.log("clilnet agnet ");       
          getClientAssignData((response) =>{
            if(response.status === 200){
              setClientAssignedData(response.data);
              setErrorMessage(['Agent Information Updated Successfully'])
              setError(true)
              setOpenDialog(false)
              setIsUpdating(false);
              setdilogListType([]);
              setDilogClientType('');
              setdilogcllientList([]);
              setEditedData([]);
              setOpenDialog(false);
              setActiveCameras([])
              setCheckValue(false)
              setClientTypeEditError(false)
              setClientEditError(false)
              setAgentEditError(false)
              setActiveEditError(false)
              setDilogCameras([])
              handleClear();
            }
          })
        }
        })
      }

      else if(List.length === 0){  //  need to remove client 
        const removeList = [];
        removeList.push({
          AgentId: existenceAgentId,
          CameraId:existingCamers.join(','),
          Type : 'remove'
        })
        setClientAgent(removeList,(response)=>{
          if(response.status === 200){
            // console.log("clilnet agnet ");       
            getClientAssignData((response) =>{
              if(response.status === 200){
                setClientAssignedData(response.data);
                setErrorMessage(['Agent Information Removed Successfully'])
                setError(true)
                setOpenDialog(false)
                setIsUpdating(false);
                setdilogListType([]);
                setDilogClientType('');
                setdilogcllientList([]);
                setEditedData([]);
                setOpenDialog(false);
                setActiveCameras([])
                setCheckValue(false)
                setClientTypeEditError(false)
                setClientEditError(false)
                setAgentEditError(false)
                setActiveEditError(false)
                setDilogCameras([])
                handleClear();
              }
            })
          }
          })
      }
      setIsUpdating(false);
      setIsButtonDisabled(false);
      setDisableAgent(false)
    }


  const handleCellClick = (item) => {
    //console.log(item.details.camera_details)
    const flattenedArray = item.details.camera_details.flat();
    setTableData(flattenedArray)
    setTableDilog(true)
  };

  const dilogClientChange = (_,val)=>{
    if(val.length === 0){
      setDisableAgent(true)
      setdilogcllientList([])
      setDilogCameras([])
      setEditClientLocationOptions([])
      setEditSelectedClientLocations([])
      setEditLocationCheckValue(false)
      setActiveCameras([])
      return
    }

    if(disableAgent){
      setDisableAgent(false)
    }

    setEditClientLocationOptions([])
    setEditSelectedClientLocations([])
    setEditLocationCheckValue(false)
    setActiveCameras([])
    setdilogcllientList([val[0]])
  }

 

  return (
    <>
      <Page title="Client Assign to Agent">
        <Container maxWidth="xxl" sx={{ p: 0 }}>
          <Card variant="outlined" sx={{ p: 3 }}>
            <CardContent>
              <Typography variant="h4">Client Assign to Agent</Typography>
              <Grid container spacing={2} alignItems="center" marginTop={4}>

                {/* Client Type Dropdown */}
                <Grid item md={2}>
                  <FormControl fullWidth error={Boolean(clientTypeError)}>
                    <InputLabel id="client-type-label" >Client Type</InputLabel>
                    <Select
                      labelId="client-type-label"
                      id="client-type"
                      value={clientType}
                      label="Client Type"
                      onChange={handleClientTypeChange}
                    >
                      <MenuItem value="US">US</MenuItem>
                      <MenuItem value="INDIA">INDIA</MenuItem>
                    </Select>
                    {clientTypeError && (
                      <Typography sx={{ fontSize: '12px',marginTop:'1px'}} color="error">{clientTypeError}</Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item md={2}>
                  <Autocomplete
                    options={clientListType}
                    getOptionLabel={(option) => option.displayname}
                    value={selectedclients[0] || null}
                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                    onChange={handleClientChange}
                    renderOption={(props, option) => (
                      <li {...props} key={option.ID}>
                        {option.displayname}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Clients"
                        error={Boolean(clientError)}
                        helperText={clientError}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                              '&::placeholder': {
                                  color: clientError ? '#FF2400' : 'gray', 
                                  opacity: 1, 
                              },
                          },
                      }}
                      sx={{
                        '& .MuiInputBase-input::placeholder': {
                            color: clientError ? '#FF2400' : 'gray', 
                            opacity: 1, 
                        },
                    }}
                      />
                    )}
                  />

                </Grid>

                {clientLocationOptions.length > 0 && (
                  <Grid item md={2}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={clientLocationOptions}
                      value={clientLocationOptions.filter((locationItem) =>
                        selectedClientLocations.includes(locationItem.ID || locationItem.id)
                      )}
                      getOptionLabel={(option) => option.selectall ? option.title : `${option.Location || ''}`}
                      onChange={handleLocationChange}
                      filterOptions={handleLocationFilterOptions}
                      renderOption={(props, option) => (
                        <li {...props}>
                          {option.selectall ? (
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                checked={locationCheckValue}
                                style={{ marginRight: 8 }}
                              />
                              {option.title}
                            </>
                          ) : (
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                checked={selectedClientLocations.includes(option.ID || option.id)}
                                style={{ marginRight: 8 }}
                              />
                              {option.Location}
                            </>
                          )}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" placeholder="Select Locations" />
                      )}
                      renderTags={() => null}
                    />
                  </Grid>
                )}

                <Grid item md={2}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    value={selectedAgent}
                    disableClearable={true}
                    options={userTypeList}
                    getOptionLabel={(option) => option.displayname}
                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                    onChange={(event, newValue) => {
                      setAgentError('')
                      setSelectedAgent(newValue)
                    }}
                    renderOption={(props, option, { selected }) => {
                      const isSelected = selectedAgent.some((agent) => agent.ID === option.ID);
                      return (
                      <li {...props} key={option.ID}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          checked={isSelected}
                          style={{ marginRight: 8 }}
                        />
                        {option.displayname}
                      </li>
                    )}}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Agents"
                        error={Boolean(agentError)}
                        helperText={agentError}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                              '&::placeholder': {
                                  color: agentError ? '#FF2400' : 'gray', 
                                  opacity: 1, 
                              },
                            },
                          }}
                          sx={{
                            '& .MuiInputBase-input::placeholder': {
                            color: agentError ? '#FF2400' : 'gray', 
                            opacity: 1, 
                            },
                          }}
                      />
                    )}
                    renderTags={() => null} 
                  />
                  {/* Display count of selected items */}

                </Grid>

                <Grid item md={2}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={clientCameraList}
                    getOptionLabel={(option) =>(option.all && clientCameraList.length===activeCameras.length)?'Select All':`${option.deviceid} ${option.devicename}`}
                    isOptionEqualToValue={(option, value) => option.uid === value.uid}
                    onChange={handleCameraSelection}
                    value={[]}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        {option.all ? (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={checkValue}
                              onChange={() => setCheckValue(!checkValue)}
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={activeCameras.includes(option.deviceid)}
                              onChange={() => {
                                const isChecked = activeCameras.includes(option.deviceid);
                                const newActiveCameras = isChecked
                                  ? activeCameras.filter((deviceId) => deviceId !== option.deviceid)
                                  : [...activeCameras, option.deviceid];
                                setActiveCameras(newActiveCameras);
                              }}
                            />
                            {`${option.devicename}`}
                          </>
                        )}
                      </li>
                    )}
                    filterOptions = {handleFilterOptions}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select Cameras"
                        error={Boolean(cameraError)}
                        helperText={cameraError}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                              '&::placeholder': {
                                  color: cameraError ? '#FF2400' : 'gray', 
                                  opacity: 1, 
                              },
                          },
                        }}
                        sx={{
                        '& .MuiInputBase-input::placeholder': {
                            color: cameraError ? '#FF2400' : 'gray', 
                            opacity: 1, 
                          },
                        }}
                      />
                    )}
                    renderTags={() => null}  // Prevents displaying selected items in the input
                  />
                  {/* Display count of selected items */}

                </Grid>

                {/* Buttons */}
                <Grid item xs={2} sx={{ height: "100%", marginTop: 2 }}>
                  <Button variant="contained" onClick={handleAdd}>
                    Add
                  </Button>
                  <Button color="error" variant="contained" onClick={handleClear} sx={{ marginLeft: 1 }}>
                    Clear
                  </Button>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={3}
                alignItems="center"
                sx={{ marginTop: "1rem" }}
              >
                <Scrollbar>
                  <TableContainer 
                  >
      
                    <Table stickyHeader>
                      <TableHead sx={{background: '#f3f3f3' }}>
                        <TableRow sx={{background: '#f3f3f3' }}>
                          <TableCell>SNo</TableCell>
                          <TableCell>Agent Name</TableCell>
                          <TableCell>ClientName</TableCell>
                          <TableCell>Location</TableCell>
                          <TableCell>Cameras</TableCell>
                        
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {Array.isArray(assignedData) && 
                        assignedData.map((item, index) => {
                            let deiviceCount = item.details.DevicesCount
                            const sum = deiviceCount.reduce((acc,val)=>{
                                return acc+val;
                            },0)
                            
                          return (
                            <TableRow key={index}>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{item.details.agent_name}</TableCell>
                              <TableCell>{item.details.ClientName.join(', ')}</TableCell>
                              <TableCell>{getAssignedLocationLabel(item)}</TableCell>
                              <TableCell>
                                <Box onClick={() => handleCellClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                                  {sum}
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Button variant="contained" onClick={()=>{
                                 
                                  setEditedData(item)
                                  setOpenDialog(true)
                                  const selectedClients = buildUniqueClientOptions(
                                    item.details.ClientId
                                      .map(clientId => clientList.find(client => client.ID === clientId))
                                      .filter(Boolean)
                                  );
                                  setdilogcllientList(selectedClients.slice(0, 1));
                                
                                  // const flattenedArray = item.details.camera_details.flat();
                                  // setActiveCameras(flattenedArray.map(camera => camera.DeviceId));   
                                }}>Edit</Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>

                    </Table>
                  </TableContainer>
                </Scrollbar>
              </Grid>
              
            </CardContent>
          </Card>
          <Dialog open={openDialog} fullWidth>
          <DialogTitle>Edit Agent Information</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} sx={{marginTop:'5px'}}>
                <FormControl fullWidth error={clientTypeEditError}>
                  <InputLabel id="client-type-label">Client Type</InputLabel>
                    <Select
                      labelId="client-type-label"
                      id="client-type"
                      value={dilogeClientType}
                      label="Client Type"
                      onChange={(e) => {
                        if(editedData && editedData.details){
                          //let type = dilogeClientType
                          let cameraInfo =activeCameras.filter(id =>!editedData.details.camera_details.flat().map(item=>item.DeviceId).includes(id)) 
                          if(cameraInfo.length !== 0){
                            setError(true)
                            setErrorMessage(['Please Assign the selected cameras to the agent before changing the client type.'])
                            return
                          }
                          else{
                            setDilogClientType(e.target.value)
                          }
                        }                   
                      }}
                      displayEmpty
                    >
                      <MenuItem value="INDIA">INDIA</MenuItem>
                      <MenuItem value="US">US</MenuItem>
                    </Select>
                    {clientTypeEditError && <FormHelperText>Please Select Client Type</FormHelperText>}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} sx={{marginTop:'5px'}}>
                <Autocomplete
                  options={dilogListType}
                  getOptionLabel={(option) => option.displayname}
                  value={dilogclients[0] || null}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID}
                  onChange={(e,val)=>{
                    dilogClientChange(e, val ? [val] : [])
                  }}
                  renderOption={(props, option) => {
                    return(
                    <li {...props} key={option.ID}>
                      {option.displayname}
                    </li>
                  )}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Clients"
                      error={clientEditError}
                      helperText={clientEditError ? "Please Select Client." : ""}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  multiple
                  disabled={disableAgent} 
                  key={selectedAgent.length}
                  disableCloseOnSelect
                  options={userTypeList}
                  getOptionLabel={(option) => option.displayname}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID}
                  value={selectedAgent}
                  onChange={(event, newValue) => setSelectedAgent(newValue)}
                  renderOption={(props, option, { selected }) => (
                    <li {...props} key={option.ID}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        checked={selected}
                        style={{ marginRight: 8 }}
                      />
                      {option.displayname}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Agents"
                      error={agentEditError}
                      helperText={agentEditError ? "Please Select Agent" : ""}
                    />          
                  )}
                  renderTags={() => null}
                />
              </Grid>

              {editClientLocationOptions.length > 0 && (
                <Grid item xs={12} sm={6}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={editClientLocationOptions}
                    value={editClientLocationOptions.filter((locationItem) =>
                      editSelectedClientLocations.includes(locationItem.ID || locationItem.id)
                    )}
                    getOptionLabel={(option) => option.selectall ? option.title : `${option.Location || ''}`}
                    onChange={handleEditLocationChange}
                    filterOptions={handleLocationFilterOptions}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.selectall ? (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={editLocationCheckValue}
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={editSelectedClientLocations.includes(option.ID || option.id)}
                            />
                            {option.Location}
                          </>
                        )}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" placeholder="Select Locations" />
                    )}
                    renderTags={() => null}
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={dilogCameras}
                  getOptionLabel={(option) => option.devicename}
                  isOptionEqualToValue={(option, value) => option.uid === value.uid}
                  value={dilogCameras.filter(camera => activeCameras.includes(camera.deviceid))}
                  onChange={handleDilogCameraSelection}
                  filterOptions={handleFilterOptions}
                  renderOption={(props, option, { selected }) => { 
                  
                    const isAllSelected = activeCameras.length === dilogCameras.length; 
                    return (
                      <li {...props}>
                        {option.all ? (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={isAllSelected} 
                              onChange={() => {
                                if (isAllSelected) {
                                  setActiveCameras([]); 
                                } else {
                                  setActiveCameras(dilogCameras.map(cam => cam.deviceid)); 
                                }
                              }}
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={activeCameras.includes(option.deviceid)} // Check if this camera is selected
                              onChange={() => {
                                const isChecked = activeCameras.includes(option.deviceid);
                                const newActiveCameras = isChecked
                                  ? activeCameras.filter((deviceId) => deviceId !== option.deviceid)
                                  : [...activeCameras, option.deviceid];
                                setActiveCameras(newActiveCameras);
                              }}
                            />
                            {`${option.deviceid} ${option.devicename}`}
                          </>
                        )}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Cameras"
                      error={activeEditError}
                      helperText={activeEditError ? "Please Select Cameras" : ""}
                    />
                  )}
                  renderTags={() => null}
                />
              </Grid>
            </Grid>
          </DialogContent>
            <DialogActions>
              <Button variant='contained' onClick={handleUpdate} disabled={isButtonDisabled}>
              {isUpdating ? 'Updating...' : 'Save'}
              </Button>
              <Button variant='contained' color='error' onClick={() => {
                setdilogListType([]);
                setDilogClientType('');
                setdilogcllientList([]);
                setEditedData([]);
                setOpenDialog(false);
                setActiveCameras([])
                setCheckValue(false)
                setClientTypeEditError(false)
                setClientEditError(false)
                setAgentEditError(false)
                setActiveEditError(false)
                setDilogCameras([])
                handleClear()
              }}>Cancel</Button>
            </DialogActions>
          </Dialog>

          <Dialog open={error}>
            <DialogContent>
              {/* {errorMessage} */}
              {errorMessage && errorMessage.map((item, index) => {
                return ( 
                  <Typography key={index} variant="body1" gutterBottom>
                    {item}
                  </Typography>
                );
              })}
            </DialogContent>
            <DialogActions>
              <Button variant='contained' color='secondary' onClick={() => setError(false)}>
              Ok
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog fullWidth open={tableDialog}>
            <DialogTitle>Device Information</DialogTitle>
            <DialogContent>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>S.No</TableCell>
                    <TableCell>Device Id</TableCell>
                    <TableCell>Device Name</TableCell>
                    <TableCell>ClientName</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {tableData && tableData.map((val, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{val.DeviceId}</TableCell>
                    <TableCell>{val.DeviceName}</TableCell>
                    <TableCell>{val.ClientName}</TableCell>
                  </TableRow>
                ))}
                </TableBody>
              </Table>
            </DialogContent>
            <DialogActions>
              <Button variant='contained' onClick={()=>{setTableDilog(false)}}>Ok</Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Page>
    </>
  );
}

export default ClientAssign;
